import { render, staticRenderFns } from "./InviteMemberPage.vue?vue&type=template&id=6a90fee6&scoped=true&"
import script from "./InviteMemberPage.vue?vue&type=script&lang=js&"
export * from "./InviteMemberPage.vue?vue&type=script&lang=js&"
import style0 from "./InviteMemberPage.vue?vue&type=style&index=0&id=6a90fee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90fee6",
  null
  
)

export default component.exports